import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const useVaultDepositStyle = createUseStyles({
    root: {
        width: '100%',
        color: color.content.primary,
        marginTop: spacing['08'],
    },
    totalSupplyWrapper: {
        width: '25%',
        fontWeight: '500 !important',
    },
    buttons: {
        width: '10%',
    },
    asset: {
        width: 250,
    },
    icon: {
        alignSelf: 'center',
    },
    tooltip: {
        '& .ant-tooltip-inner': {
            padding: `${spacing['03']} ${spacing['04']}`,
            fontSize: 12,
        },
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: 16,
        gap: 4,
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        padding: `0 ${spacing['05']} ${spacing['05']} ${spacing['05']}`,
        gap: spacing['07'],
    },
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: spacing['03'],
    },
    searchInput: {
        width: 250,
        border: `1px solid ${color.border.opaque}`,
        borderRadius: 4,
        height: 44,
        backgroundColor: color.background.primary,
    },
    selectInput: {
        width: 250,
        border: `1px solid ${color.border.opaque}`,
        borderRadius: 4,
        height: 44,
        backgroundColor: color.background.primary,
        '& .ant-select-selector': {
            backgroundColor: `${color.background.primary} !important`,
            boxShadow: `none !important`,
            borderRadius: `4px !important`,
            borderColor: `transparent !important`,
        },
    },
    apyTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: spacing['03'],
    },
});
